/* eslint-disable import/order */
import qs from 'qs';
import { CardHolder } from '~/types/Cardholder';
import axios from './axios';
import { getDecodedJwt } from '~/utils/getDecodedJwt';

export const getCardHolder = () => {
  const decodeToken = getDecodedJwt();
  const email = decodeToken?.email;
  return axios.get<any>('/cardholder/byEmail?', { params: { email } }).then((res) => res.data);
};

export const saveCardHolder = (data: any) => {
  return axios.post<CardHolder>('/cardholder/details', data).then((res) => res.data);
};

export const createCardholder = (body: any) => {
  return axios.post<any>('/cardholder/create', body).then((res) => res.data);
};
export const deleteCardholder = async (body: { cardholderId: string; role: string }) => {
  const { cardholderId, role } = body;
  const res = await axios.post<any>(`/cardholder/delete?cardHolderId=${cardholderId}&role=${role}`);
  return res.data;
};

export const updateCardholder = (body: any) => {
  return axios.post<any>(`/cardholder/update`, body).then((res) => res.data);
};
export const sendInvitaion = (body: any) => {
  return axios.post<any>(`/stages/fillApplication/sendInvitation/cardHolder`, body).then((res) => res.data);
};
export const checkStatus = async () => {
  const response = await axios.get<any>(`/cardholder/checkStatus`).then((res) => {
    return res.data;
  });
  return response;
};

export const resetCardholders = async (unselectedCard: string) => {
  const response = await axios.post<any>(`/cardholder/reset?roles=${unselectedCard}`).then((res) => {
    return res?.data;
  });
  return response;
};
export const getAllCardholders = async () => {
  try {
    const response = await axios.get<any>(`/cardholder`);
    return response?.data;
  } catch (error) {
    return [];
  }
};
